export default "__VITE_ASSET__BS3vX0S4__"